module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading..."},"de":{"loading":"Wird geladen..."},"fr":{"loading":"Chargement..."},"it":{"loading":"Caricamento..."}}')
  delete Component.options._Ctor
}
